/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { StorageUnitNotificationRegistration } from '../model/storageUnitNotificationRegistration';
import { StorageUnitNotificationRegistrationCreateRequest } from '../model/storageUnitNotificationRegistrationCreateRequest';
import { StorageUnitNotificationRegistrationKeys } from '../model/storageUnitNotificationRegistrationKeys';
import { StorageUnitNotificationRegistrationUpdateRequest } from '../model/storageUnitNotificationRegistrationUpdateRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class StorageUnitNotificationRegistrationService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createStorageUnitNotificationRegistration
     * Creates a new storage unit notification registration. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt; &lt;p&gt;Requires READ permission on filter namespace&lt;/p&gt; &lt;p&gt;Requires EXECUTE permission on ALL job action namespaces&lt;/p&gt;
     * @param storageUnitNotificationRegistrationCreateRequest the information needed to create the storage unit notification registration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storageUnitNotificationRegistrationCreateStorageUnitNotificationRegistration(storageUnitNotificationRegistrationCreateRequest: StorageUnitNotificationRegistrationCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<StorageUnitNotificationRegistration>;
    public storageUnitNotificationRegistrationCreateStorageUnitNotificationRegistration(storageUnitNotificationRegistrationCreateRequest: StorageUnitNotificationRegistrationCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StorageUnitNotificationRegistration>>;
    public storageUnitNotificationRegistrationCreateStorageUnitNotificationRegistration(storageUnitNotificationRegistrationCreateRequest: StorageUnitNotificationRegistrationCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StorageUnitNotificationRegistration>>;
    public storageUnitNotificationRegistrationCreateStorageUnitNotificationRegistration(storageUnitNotificationRegistrationCreateRequest: StorageUnitNotificationRegistrationCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (storageUnitNotificationRegistrationCreateRequest === null || storageUnitNotificationRegistrationCreateRequest === undefined) {
            throw new Error('Required parameter storageUnitNotificationRegistrationCreateRequest was null or undefined when calling storageUnitNotificationRegistrationCreateStorageUnitNotificationRegistration.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<StorageUnitNotificationRegistration>(`${this.configuration.basePath}/notificationRegistrations/storageUnitNotificationRegistrations`,
            storageUnitNotificationRegistrationCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteStorageUnitNotification
     * Deletes an existing storage unit notification registration by key. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace of the storage unit notification registration
     * @param notificationName the name of the storage unit notification registration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storageUnitNotificationRegistrationDeleteStorageUnitNotification(namespace: string, notificationName: string, observe?: 'body', reportProgress?: boolean): Observable<StorageUnitNotificationRegistration>;
    public storageUnitNotificationRegistrationDeleteStorageUnitNotification(namespace: string, notificationName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StorageUnitNotificationRegistration>>;
    public storageUnitNotificationRegistrationDeleteStorageUnitNotification(namespace: string, notificationName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StorageUnitNotificationRegistration>>;
    public storageUnitNotificationRegistrationDeleteStorageUnitNotification(namespace: string, notificationName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling storageUnitNotificationRegistrationDeleteStorageUnitNotification.');
        }
        if (notificationName === null || notificationName === undefined) {
            throw new Error('Required parameter notificationName was null or undefined when calling storageUnitNotificationRegistrationDeleteStorageUnitNotification.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<StorageUnitNotificationRegistration>(`${this.configuration.basePath}/notificationRegistrations/storageUnitNotificationRegistrations/namespaces/${encodeURIComponent(String(namespace))}/notificationNames/${encodeURIComponent(String(notificationName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getStorageUnitNotificationRegistration
     * Gets an existing storage unit notification registration by key. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param namespace the namespace of the storage unit notification registration
     * @param notificationName the name of the storage unit notification registration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storageUnitNotificationRegistrationGetStorageUnitNotificationRegistration(namespace: string, notificationName: string, observe?: 'body', reportProgress?: boolean): Observable<StorageUnitNotificationRegistration>;
    public storageUnitNotificationRegistrationGetStorageUnitNotificationRegistration(namespace: string, notificationName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StorageUnitNotificationRegistration>>;
    public storageUnitNotificationRegistrationGetStorageUnitNotificationRegistration(namespace: string, notificationName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StorageUnitNotificationRegistration>>;
    public storageUnitNotificationRegistrationGetStorageUnitNotificationRegistration(namespace: string, notificationName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling storageUnitNotificationRegistrationGetStorageUnitNotificationRegistration.');
        }
        if (notificationName === null || notificationName === undefined) {
            throw new Error('Required parameter notificationName was null or undefined when calling storageUnitNotificationRegistrationGetStorageUnitNotificationRegistration.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<StorageUnitNotificationRegistration>(`${this.configuration.basePath}/notificationRegistrations/storageUnitNotificationRegistrations/namespaces/${encodeURIComponent(String(namespace))}/notificationNames/${encodeURIComponent(String(notificationName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getStorageUnitNotificationRegistrationsByNamespace
     * Gets a list of keys for all existing storage unit notification registrations for the specified storage unit notification registration namespace.
     * @param namespace the namespace of the storage unit notification registration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storageUnitNotificationRegistrationGetStorageUnitNotificationRegistrationsByNamespace(namespace: string, observe?: 'body', reportProgress?: boolean): Observable<StorageUnitNotificationRegistrationKeys>;
    public storageUnitNotificationRegistrationGetStorageUnitNotificationRegistrationsByNamespace(namespace: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StorageUnitNotificationRegistrationKeys>>;
    public storageUnitNotificationRegistrationGetStorageUnitNotificationRegistrationsByNamespace(namespace: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StorageUnitNotificationRegistrationKeys>>;
    public storageUnitNotificationRegistrationGetStorageUnitNotificationRegistrationsByNamespace(namespace: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling storageUnitNotificationRegistrationGetStorageUnitNotificationRegistrationsByNamespace.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<StorageUnitNotificationRegistrationKeys>(`${this.configuration.basePath}/notificationRegistrations/storageUnitNotificationRegistrations/namespaces/${encodeURIComponent(String(namespace))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getStorageUnitNotificationRegistrationsByNotificationFilter
     * &lt;p&gt; Gets a list of keys for all existing storage unit notification registrations that match the specified storage unit notification filter parameters. &lt;/p&gt; &lt;p&gt; This endpoint requires both namespace and name of the business object definition. &lt;/p&gt; &lt;p&gt;Requires READ permission on business object definition namespace&lt;/p&gt;
     * @param businessObjectDefinitionNamespace the namespace of the business object definition
     * @param businessObjectDefinitionName the name of the business object definition
     * @param businessObjectFormatUsage the usage of the business object format
     * @param businessObjectFormatFileType the file type of the business object format
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storageUnitNotificationRegistrationGetStorageUnitNotificationRegistrationsByNotificationFilter(businessObjectDefinitionNamespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage?: string, businessObjectFormatFileType?: string, observe?: 'body', reportProgress?: boolean): Observable<StorageUnitNotificationRegistrationKeys>;
    public storageUnitNotificationRegistrationGetStorageUnitNotificationRegistrationsByNotificationFilter(businessObjectDefinitionNamespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage?: string, businessObjectFormatFileType?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StorageUnitNotificationRegistrationKeys>>;
    public storageUnitNotificationRegistrationGetStorageUnitNotificationRegistrationsByNotificationFilter(businessObjectDefinitionNamespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage?: string, businessObjectFormatFileType?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StorageUnitNotificationRegistrationKeys>>;
    public storageUnitNotificationRegistrationGetStorageUnitNotificationRegistrationsByNotificationFilter(businessObjectDefinitionNamespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage?: string, businessObjectFormatFileType?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectDefinitionNamespace === null || businessObjectDefinitionNamespace === undefined) {
            throw new Error('Required parameter businessObjectDefinitionNamespace was null or undefined when calling storageUnitNotificationRegistrationGetStorageUnitNotificationRegistrationsByNotificationFilter.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling storageUnitNotificationRegistrationGetStorageUnitNotificationRegistrationsByNotificationFilter.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (businessObjectDefinitionNamespace !== undefined && businessObjectDefinitionNamespace !== null) {
            queryParameters = queryParameters.set('businessObjectDefinitionNamespace', <any>businessObjectDefinitionNamespace);
        }
        if (businessObjectDefinitionName !== undefined && businessObjectDefinitionName !== null) {
            queryParameters = queryParameters.set('businessObjectDefinitionName', <any>businessObjectDefinitionName);
        }
        if (businessObjectFormatUsage !== undefined && businessObjectFormatUsage !== null) {
            queryParameters = queryParameters.set('businessObjectFormatUsage', <any>businessObjectFormatUsage);
        }
        if (businessObjectFormatFileType !== undefined && businessObjectFormatFileType !== null) {
            queryParameters = queryParameters.set('businessObjectFormatFileType', <any>businessObjectFormatFileType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<StorageUnitNotificationRegistrationKeys>(`${this.configuration.basePath}/notificationRegistrations/storageUnitNotificationRegistrations`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateStorageUnitNotificationRegistration
     * Updates an existing storage unit notification registration by key. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt; &lt;p&gt;Requires READ permission on filter namespace&lt;/p&gt; &lt;p&gt;Requires EXECUTE permission on ALL job action namespaces&lt;/p&gt;
     * @param namespace the namespace of the storage unit notification registration
     * @param notificationName the name of the storage unit notification registration
     * @param storageUnitNotificationRegistrationUpdateRequest the information needed to update the storage unit notification registration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storageUnitNotificationRegistrationUpdateStorageUnitNotificationRegistration(namespace: string, notificationName: string, storageUnitNotificationRegistrationUpdateRequest: StorageUnitNotificationRegistrationUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<StorageUnitNotificationRegistration>;
    public storageUnitNotificationRegistrationUpdateStorageUnitNotificationRegistration(namespace: string, notificationName: string, storageUnitNotificationRegistrationUpdateRequest: StorageUnitNotificationRegistrationUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StorageUnitNotificationRegistration>>;
    public storageUnitNotificationRegistrationUpdateStorageUnitNotificationRegistration(namespace: string, notificationName: string, storageUnitNotificationRegistrationUpdateRequest: StorageUnitNotificationRegistrationUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StorageUnitNotificationRegistration>>;
    public storageUnitNotificationRegistrationUpdateStorageUnitNotificationRegistration(namespace: string, notificationName: string, storageUnitNotificationRegistrationUpdateRequest: StorageUnitNotificationRegistrationUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling storageUnitNotificationRegistrationUpdateStorageUnitNotificationRegistration.');
        }
        if (notificationName === null || notificationName === undefined) {
            throw new Error('Required parameter notificationName was null or undefined when calling storageUnitNotificationRegistrationUpdateStorageUnitNotificationRegistration.');
        }
        if (storageUnitNotificationRegistrationUpdateRequest === null || storageUnitNotificationRegistrationUpdateRequest === undefined) {
            throw new Error('Required parameter storageUnitNotificationRegistrationUpdateRequest was null or undefined when calling storageUnitNotificationRegistrationUpdateStorageUnitNotificationRegistration.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<StorageUnitNotificationRegistration>(`${this.configuration.basePath}/notificationRegistrations/storageUnitNotificationRegistrations/namespaces/${encodeURIComponent(String(namespace))}/notificationNames/${encodeURIComponent(String(notificationName))}`,
            storageUnitNotificationRegistrationUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
